import momentGenerateConfig from "rc-picker/es/generate/moment";
import generateCalendar from './generateCalendar';
var Calendar = generateCalendar(momentGenerateConfig);
export default Calendar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/calendar/index.js
// module id = 689
// module chunks = 0